export default __webpack_public_path__ + "static/heroFinal-8183c8f7292eed59d87be2ec6dd9074c.svg";